import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-landing-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
    displayLogin = false;
    displayTrackButton = false;
    trackingId: string = null;

    constructor() {
    }

    ngOnInit(): void {
    }

}
